import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CheckCircle, ShieldCheck, FileCheck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { homePathForRole } from '../utils/roleHome';
import ClientRegisterForm from '../components/ClientRegisterForm';
import './AuthPage.css';

export default function RegisterPage() {
  const { t } = useLanguage();
  const { register, user, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && isAuthenticated && user) {
      navigate(homePathForRole(user.role) || '/', { replace: true });
    }
  }, [loading, isAuthenticated, user, navigate]);

  const handleSubmit = (payload) => register(payload);

  const perks = [
    { icon: ShieldCheck, text: t.auth.perkSecure },
    { icon: FileCheck, text: t.auth.perkOrders },
    { icon: CheckCircle, text: t.auth.perkDocs },
  ];

  return (
    <div className="auth-page">
      <div className="auth-shell auth-shell--register">
        <aside className="auth-brand-panel">
          <div className="auth-brand-glow" aria-hidden="true" />
          <div className="auth-brand-content">
            <p className="auth-brand-name">
              Tarjemlek
              <span lang="ar">ترجملك</span>
            </p>
            <h1>{t.auth.registerTitle}</h1>
            <p className="auth-brand-text">{t.auth.registerSubtitle}</p>
            <ul className="auth-perks">
              {perks.map(({ icon: Icon, text }) => (
                <li key={text}>
                  <Icon size={18} aria-hidden="true" />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>
        </aside>

        <div
          className="auth-form-panel"
          style={{
            alignItems: 'flex-start',
            justifyContent: 'center',
            padding: '24px 32px',
          }}
        >
          <ClientRegisterForm
            mode="register"
            onSubmit={handleSubmit}
            successMessage={t.auth.registerSuccess}
            onSuccess={() => navigate('/login', { state: { registered: true } })}
            title={t.auth.registerTitle}
            subtitle={t.auth.registerSubtitle}
            footer={
              <p className="auth-switch" style={{ marginTop: '16px', fontSize: '0.85rem' }}>
                {t.auth.hasAccount}{' '}
                <Link to="/login">{t.auth.loginLink}</Link>
              </p>
            }
          />
        </div>
      </div>
    </div>
  );
}
